import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { CallToActionComponent } from "@hermes/aphrodite-call-to-action";

import { ShellStateModule } from "@hermes/domains-shell-states-shell-state";
import { TRAY_COMPONENT, TrayStateModule } from "@hermes/hermes-web-states-tray-state";

import { GeofilteringTrayComponent } from "./components/geofiltering-tray/geofiltering-tray.component";

import { GeofilteringTrayAnalyticsService } from "./services/geofiltering-tray-analytics.service";
import { GeofilteringTrayService } from "./services/geofiltering-tray.service";

@NgModule({
    imports: [
        CommonModule,
        TrayStateModule,
        CallToActionComponent,
        TranslateModule,
        ShellStateModule,
        GeofilteringTrayComponent,
    ],
    providers: [
        {
            provide: TRAY_COMPONENT,
            useValue: GeofilteringTrayComponent,
        },
        GeofilteringTrayService,
        GeofilteringTrayAnalyticsService,
    ],
})
export class GeoFilteringTrayModule {}
